import { SortingState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import TableContainer from "Common/TableContainer";
import SearchBox from "Components/SearchBox/SearchBox";
import { app_modules } from "helpers/apps_modules_list";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { createSelector } from "reselect";
import {
  exportCategoryCSV,
  fethConfigAttributes as OnfethConfigAttributes,
} from "slices/attributes/config_attributes/thunk";
import { fetchLatestPermissions } from "slices/auth/login/thunk";

const ConfigAttributesLList = () => {
  document.title = "Attribute";
  const dispatch = useDispatch<any>();
  const { id } = useParams();
  const location = useLocation();
  const attributeName = location.state?.name;
  const attribute_id = location.state?.attribute_id || id;

  console.log("Editing ID:", id);
  // console.log("Brand data:", brandData);

  // Redux selector for category state
  const selectBrands = createSelector(
    (state: any) => state.configAttribute,
    (brand) => ({
      categories: brand.configAttributeList ?? [],
      rowCount: brand.rowCount ?? 0,
      loading: brand.loading,
      error: brand.error,
      attributeDetails: brand.attributeDetails ?? null,
    })
  );

  const { categories, rowCount, loading, error, attributeDetails } =
    useSelector(selectBrands);
  console.log(categories, "categories");

  // // Extract attribute_name from categories data
  // const attributeName = useMemo(() => {
  //   if (categories && categories.length > 0) {
  //     const name = categories[0]?.attribute_name;
  //     console.log("Dynamic attribute_name:", name);
  //     return name;
  //   }
  //   return null;
  // }, [categories]);

  const user = useSelector((state: any) => state.Login.user);
  const user_permissions = user?.permissions || [];
  const master_permissions = user_permissions?.find(
    (item: any) => item?.apps_name === app_modules?.master?.app_name
  );
  const category_permissions = master_permissions?.modules_permissions?.find(
    (item: any) => item?.modules_name === app_modules?.master?.modules?.category
  );

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
      }
    };
    fetchPermissions();
  }, [dispatch]);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(rowCount);
  const [isStatusUpdateLoading, setIsStatusUpdateLoading] =
    useState<boolean>(false);
  const [editCategory, setEditCategory] = useState<boolean>(false);
  const [columnFilters, setColumnFilters] = useState<any>();
  const [edit, setEdit] = useState<any>();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [filterValue, setFilterValue] = useState<any[]>([]);
  const sortField = sorting[0]?.id ?? "";
  const sortDirection = sorting[0]?.desc ? "desc" : "asc";
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      OnfethConfigAttributes({
        page: pageIndex + 1,
        pageSize,
        sort: sortField,
        order: sortField ? sortDirection : "",
        search,
        filters: filterValue,
        attribute_id: attribute_id,
      })
    );
  }, [dispatch, pageIndex, pageSize, sorting, search, filterValue]);

  useEffect(() => {
    setData(categories);
  }, [categories]);

  useEffect(() => {
    setPageIndex(0);
  }, [sorting, pageSize, columnFilters]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(searchInput);
      setPageIndex(0);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const result = await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
      }
    };
    fetchPermissions();
  }, [dispatch]);

  const handleEdit = (item: any) => {
    setEditCategory(!editCategory);
    setEdit({
      ...item,
    });
    setPageIndex(0); // reset pagination
    setFilterValue([]); // reset column filters
  };

  const handleStatusToggle = async (pkg: any) => {
    console.log(pkg);
    try {
      const updatedStatus = !pkg.status;

      const payload = {
        brand_name: pkg.brand_name,
        status: updatedStatus,
      };

      setIsStatusUpdateLoading(true);

      await Axios.patch(
        `/api/manage-values/edit-status/${pkg.manage_values_id}/`,
        payload
      );

      toast.success(
        `Attribute ${updatedStatus ? "activated" : "deactivated"} successfully`
      );

      dispatch(
        OnfethConfigAttributes({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? sortDirection : "",
          search,
          filters: filterValue,
          attribute_id: attribute_id,
        })
      );
    } catch (err: any) {
      toast.error("Failed to update status");
    } finally {
      setIsStatusUpdateLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      const { blob, filename } = await exportCategoryCSV({
        search,
        filters: filterValue,
      });

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed", error);
      toast.error("Failed to export CSV");
    }
  };

  const DynamicAction =
    category_permissions?.permissions?.Update === true
      ? [
          {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }: { row: any }) => (
              <ul className="d-flex gap-2 list-unstyled mb-0">
                <li>
                  <Link
                    to={`/config-attribute-form-edit/${attribute_id}`}
                    className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                    onClick={() => handleEdit(row.original)}
                  >
                    <i className="ph-pencil"></i>
                  </Link>
                </li>
              </ul>
            ),  
          },
        ]
      : [];

  // Dynamic columns with attribute name from categories data
  const columns = useMemo(() => {
    const displayName = attributeName || "Attribute Name";

    return [
      // {
      //   header: "Sr. No.",
      //   id: "sr_no",
      //   enableSorting: false,
      //   enableColumnFilter: false,
      //   cell: ({ row }: { row: any }) => {
      //     return row.index + 1 + pageIndex * pageSize;
      //   },
      // },
      {
        header: displayName, // Dynamic attribute name from categories
        accessorKey: "value",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "dropdown" as const,
        filterFetchUrl: `/api/manage-values/column-filter-dropdown/?attribute=${id}&column_filter=value`,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const pkg = row.original;
          return (
            <div
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleStatusToggle(pkg)}
            >
              <i
                className={`bi ${
                  pkg.status
                    ? "bi-toggle-on text-primary"
                    : "bi-toggle-off text-danger"
                }`}
              />
            </div>
          );
        },
      },
      {
        header: "Created Date",
        accessorKey: "created_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.created_by_name ?? "N/A";
          const date = row.original.created_at
            ? new Date(row.original.created_at).toISOString().split("T")[0]
            : "N/A";
          return `${name}-${date}`;
        },
      },
      {
        header: "Updated Date",
        accessorKey: "updated_at",
        enableColumnFilter: true,
        enableSorting: true,
        filterType: "date" as const,
        cell: ({ row }: { row: any }) => {
          const name = row.original.updated_by_name ?? "N/A";
          const date = row.original.updated_at
            ? new Date(row.original.updated_at).toISOString().split("T")[0]
            : "N/A";
          return `${name}-${date}`;
        },
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          return (
            <ul className="d-flex gap-2 list-unstyled mb-0">
              <li>
                <Link
                  to={`/config-attribute-form-edit/${row.original.manage_values_id}`}
                  state={{ attribute_name: attributeName, attribute_id: attribute_id, manage_value: row.original }}
                  className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                >
                  <i className="ph-pencil"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ];
  }, [attributeName, pageIndex, pageSize, attribute_id]);

  function handleChange(e: any): void {
    setSearchInput(e.target.value);
  }

  // Get dynamic page title and header
  const getPageTitle = () => {
    if (attributeName) {
      return `Manage ${attributeName}`;
    }
    return "Manage Values";
  };

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Row id="invoiceList">
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <Row className="align-items-center g-2">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "10px",
                        marginTop: "-10px",
                        gap: "5px",
                        textDecoration: "none",
                      }}
                      className="my-3 "
                    >
                      <span
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          navigate(-1);
                        }}
                      >
                        Attribute
                      </span>

                      <span>&gt;</span>

                      <span
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        Manage Value
                      </span>
                    </div>

                    <Col lg={3} className="me-auto d-flex align-items-center">
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          marginRight: "8px",
                        }}
                        onClick={() => navigate(-1)}
                      >
                        ←
                      </span>
                      <h6 className="card-title mb-0">{getPageTitle()}</h6>
                    </Col>
                    {/* <Col xl={2} md={3}>
                      <div className="search-box">
                        <Form.Control
                          type="text"
                          className="search"
                          placeholder={`Search ${
                            attributeName || "attributes"
                          }...`}
                          onChange={(e: any) => handleChange(e)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col> */}

                    {/* Search Input Box (reusable)*/}
                    <Col xl={2} md={3}>
                      <SearchBox
                        value={searchInput}
                        onChange={setSearchInput}
                      />
                    </Col>


                    <Col className="col-md-auto">
                      <div className="hstack gap-2">
                        <Button
                          className="btn btn-subtle-danger d-none"
                          id="remove-actions"
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>

                        <Link
                          to={`/config-attribute-form/${attribute_id}`}
                          state={{ attribute_id }}
                          className="btn"
                          style={{
                            backgroundColor: "#0073BB",
                            borderColor: "#0073BB",
                            color: "#fff",
                          }}
                        >
                          <i className="bi bi-plus-circle align-baseline me-1"></i>{" "}
                          Add {attributeName || "Value"}
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body className="mt-3">
                  {loading || isStatusUpdateLoading ? (
                    <div className="text-center py-4">
                      <h5>Loading...</h5>
                    </div>
                  ) : error ? (
                    <div className="text-center py-4">
                      <h5>Error: {error}</h5>
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={data}
                      totalRecords={rowCount}
                      pageIndex={pageIndex}
                      pageSize={pageSize}
                      onPageChange={setPageIndex}
                      onPageSizeChange={setPageSize}
                      columnFilters={columnFilters}
                      setColumnFilters={setColumnFilters}
                      sorting={sorting}
                      onSortingChange={setSorting}
                      isBordered={false}
                      isPagination={true}
                      isGlobalFilter={false}
                      SearchPlaceholder={`Search ${
                        attributeName || "attributes"
                      }...`}
                      manualSorting={true}
                      colValue={setFilterValue}
                    />
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default ConfigAttributesLList;
